module.exports = __webpack_public_path__ + "media/images/no_image-0f992d91.png";